// Tasting Detail Gallery Slider (Mobile Only) - Using Slick
(function() {
  'use strict';

  // jQueryとSlickが読み込まれるまで待機
  function waitForDependencies(callback) {
    if (typeof jQuery !== 'undefined' && typeof jQuery.fn.slick !== 'undefined') {
      callback(jQuery);
    } else {
      setTimeout(function() {
        waitForDependencies(callback);
      }, 50);
    }
  }

  waitForDependencies(function($) {
    $(document).ready(function() {
      console.log('Tasting gallery script loaded');

      function initSlick() {
        const isMobile = window.innerWidth <= 768;
        const $galleries = $('.tasting-detail_gallery--mobile .tasting-detail_gallery-container');

        console.log('Found mobile galleries:', $galleries.length);

        if ($galleries.length === 0) {
          console.log('No galleries found');
          return;
        }

        $galleries.each(function(index) {
          const $gallery = $(this);
          const isSlickInitialized = $gallery.hasClass('slick-initialized');

          console.log(`Gallery ${index}: isMobile=${isMobile}, isInitialized=${isSlickInitialized}`);

          if (isMobile && !isSlickInitialized) {
            // モバイル: Slickを初期化
            try {
              $gallery.slick({
                dots: true,
                arrows: false,
                infinite: false,
                speed: 300,
                slidesToShow: 1,
                slidesToScroll: 1,
                swipe: true,
                // touchMove: true,
                // adaptiveHeight: true,
                mobileFirst: true,
                lazyLoad: 'ondemand',
                customPaging: function(slider, i) {
                  return '<button class="tasting-detail_gallery-indicator" data-slide="' + i + '" aria-label="画像' + (i + 1) + '"></button>';
                },
                dotsClass: 'tasting-detail_gallery-indicators'
              });

              console.log(`Gallery ${index} initialized with Slick`);
            } catch (error) {
              console.error(`Failed to initialize Slick for gallery ${index}:`, error);
            }

          } else if (!isMobile && isSlickInitialized) {
            // PC: Slickを破棄
            try {
              $gallery.slick('unslick');
              console.log(`Gallery ${index} unslicked`);
            } catch (error) {
              console.error(`Failed to unslick gallery ${index}:`, error);
            }
          }
        });
      }

      // レイアウト完了後に初期化（画像読み込みを待つ）
      if (document.readyState === 'complete') {
        initSlick();
      } else {
        $(window).on('load', function() {
          initSlick();
        });
      }

      // リサイズ時の処理（デバウンス付き）
      let resizeTimer;
      $(window).on('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
          initSlick();
        }, 250);
      });
    });
  });
})();
